(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesPropertiesController', TabObjectTypesPropertiesController);

    TabObjectTypesPropertiesController.$inject = ['$state', '$stateParams', '$scope', 'properties', 'occurrence', '$uibModal', 'paginationConstants', 'editableOptions', 'TabObjectProperties'];

    function TabObjectTypesPropertiesController($state, $stateParams, $scope, properties, occurrence, $uibModal, paginationConstants, editableOptions, TabObjectProperties) {
        var vm = this;
        var editedProperty = {};
        vm.saveReference = saveReference;
        vm.init = init;
        vm.checkValueBeforeSave = checkValueBeforeSave;
        vm.checkBeforeExit = checkBeforeExit;
        vm.checkNoPendingEdit = checkNoPendingEdit;
        vm.reloadState = reloadState;
        vm.save = save;
        vm.showOldValue = showOldValue;
        vm.openModal = openModal;
        editableOptions.theme = 'bs3';
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.objects = $stateParams.objects;
        vm.properties = properties;
        vm.occurrence = occurrence;

        function init() {
            if (vm.objects == undefined || vm.objects == null || !vm.objects.length > 0) {
                $state.go("massive-properties");
            }
        }


        function saveReference(data) {
            editedProperty[data.id] = data;
            save();
        }

        function checkValueBeforeSave(data) {
            return data ? true : "Value cannot be empty";
        }

        function checkBeforeExit() {
            if (checkNoPendingEdit()) {
                window.history.back();
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objects-properties-dialog.html'
                }).result.then(function () {
                    window.history.back();
                }, function () {
                    //null
                });
            }
        }

        function reloadState() {
            $state.transitionTo($state.current, $stateParams, {
                reload: true
            });
        }

        function checkNoPendingEdit() {
            return angular.equals({}, editedProperty);
        }

        function save() {
            if (!checkNoPendingEdit()) {
                var sendingProperties = [];
                for (var key in editedProperty) {
                    sendingProperties.push(editedProperty[key]);
                }
                vm.objects.forEach(function (id) {
                    TabObjectProperties.update({
                        properties: sendingProperties,
                        objectUniqueCode: id
                    }, onSaveSuccess);
                });
            }
        }

        function onSaveSuccess() {
            editedProperty = {};
        }


        function showOldValue(propertyName) {
            return vm.occurrence.hasOwnProperty(propertyName);
        }

        function openModal(propertyName) {
            var subScope = $scope.$new(true);
            subScope.values = vm.occurrence[propertyName];
            subScope.propertyName = propertyName;
            $uibModal.open({
                templateUrl: 'app/entities/tab-objects/tab-objectstype-properties-old-value-dialog.html',
                controller: 'TabObjectsTypesPropertiesDialogController',
                controllerAs: 'vm',
                scope: subScope,
                resolve:{
                    warnings:[function(){
                        return {};
                    }]
                }
            });
        }

        vm.init();

    }
})();
